import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import React, { useState } from "react";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { showError, showSuccess } from "@/shared/utils/toast";
import CommonInput from "@/shared/components/ui/Input/CommonInput";

const ForgotModal = ({
  showForgotModal,
  setShowForgotModal,
  forgotPasswordMutation,
}) => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const handleSendResetLink = async () => {
    console.log("[ForgotModal] handleSendResetLink triggered. Email:", email);
    console.log("[ForgotModal] forgotPasswordMutation prop:", forgotPasswordMutation);
    if (!email.trim()) {
      showError("Please enter your email address.");
      return;
    }
    try {
      console.log("[ForgotModal] Invoking forgotPasswordMutation.mutateAsync...");
      const result = await forgotPasswordMutation.mutateAsync(email.trim());
      console.log("[ForgotModal] mutateAsync success! Result:", result);
      showSuccess(result.message);
      setShowForgotModal(false);
      setEmail("");
    } catch (error) {
      console.error("[ForgotModal] mutateAsync error occurred:", error);
      showError(error.message);
    }
  };
  const isSendingResetLink = forgotPasswordMutation.isPending;
  return (
    <CustomModal
      isOpen={showForgotModal}
      onClose={() => setShowForgotModal(false)}
      width="430px"
      className="p-6 rounded-lg "
    >
      <div className="flex flex-col gap-7">
        <div className="flex justify-between items-center">
          <h3 className="text-base font-semibold text-black font-inter">
            Reset Your Password
          </h3>
          <button
            className="p-1 hover:bg-gray-100 rounded-full"
            onClick={() => setShowForgotModal(false)}
          >
            <X size={20} color="#181D27" />
          </button>
        </div>
        <div className="flex flex-col gap-2.5 -mt-4">
          <p className="text-sm font-normal text-gray-500 font-inter">
            Tell us your email ID, and we will send you instructions on how to
            reset your password
          </p>
        </div>

        {/* email input */}
        <div className="flex flex-col gap-5">
          <CommonInput
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="underline"
          />
          <div className="flex flex-col gap-2">
            <PrimaryButton
              onClick={handleSendResetLink}
              disabled={isSendingResetLink}
              isLoading={isSendingResetLink}
              startContent={false}
              className="w-full rounded-full px-3 py-6 text-sm font-inter font-normal"
            >
              Send Instructions
            </PrimaryButton>
            <p
              className="text-xs text-center text-gray-400 font-inter underline
             cursor-pointer hover:text-secondary transition-colors"
              onClick={() => {
                setShowForgotModal(false);
                setEmail("");
                navigate(-1);
              }}
            >
              Back to Log in
            </p>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default ForgotModal;
